module.exports = __webpack_public_path__ + "images/f75eda5838582d2fda71921fbc114cb9.svg";